import React from 'react'

import { Helmet } from 'react-helmet'

import './blog.css'

const Blog = (props) => {
  return (
    <div className="blog-container">
      <Helmet>
        <title>
          FutureHeirs | Faith-Based Non-Profit Empowering Future Leaders
        </title>
      </Helmet>
      <div className="blog-blog">
        <div className="blog-frame121">
          <div className="blog-frame14">
            <div className="blog-frame162">
              <img
                alt="VectorI290"
                src="/external/vectori290-flen.svg"
                className="blog-vector1"
              />
              <span className="blog-text100">futureheirs</span>
            </div>
            <div className="blog-frame81">
              <div className="blog-frame6">
                <span className="blog-text101">Home</span>
              </div>
              <div className="blog-frame7">
                <span className="blog-text102">About Us</span>
              </div>
              <div className="blog-frame82">
                <span className="blog-text103">Contact Us</span>
              </div>
              <div className="blog-frame9">
                <span className="blog-text104">Blog</span>
              </div>
            </div>
            <div className="blog-component41">
              <span className="blog-text105">Join Us</span>
            </div>
          </div>
          <div className="blog-frame131">
            <div className="blog-frame195">
              <img
                alt="Line652901"
                src="/external/line652901-884.svg"
                className="blog-line65"
              />
              <span className="blog-text106">Blog</span>
            </div>
            <span className="blog-text107">
              Explore insights, stories, and updates on education, technology,
              and personal growth.
            </span>
          </div>
        </div>
        <img
          alt="Rectangle42901"
          src="/external/rectangle42901-98b5.svg"
          className="blog-rectangle4"
        />
        <div className="blog-frame1139">
          <div className="blog-frame1140">
            <div className="blog-frame1141">
              <div className="blog-frame2181">
                <span className="blog-text108">Latest Post</span>
                <span className="blog-text109">
                  Stay updated with our latest insights, stories, and resources.
                </span>
              </div>
              <div className="blog-frame269">
                <div className="blog-frame2182">
                  <div className="blog-frame267">
                    <div className="blog-frame266">
                      <div className="blog-frame2501">
                        <span className="blog-text110">Insight</span>
                        <img
                          alt="Ellipse143092"
                          src="/external/ellipse143092-slmr-200h.png"
                          className="blog-ellipse141"
                        />
                        <span className="blog-text111">March 15, 2025</span>
                      </div>
                      <span className="blog-text112">
                        Transforming Education in Rural Nigeria: Our Tech Camp
                        Success Story
                      </span>
                    </div>
                    <span className="blog-text113">
                      <span className="blog-text114">
                        By
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span className="blog-text115">Sarah Adeyemi,</span>
                      <span> Program Director</span>
                    </span>
                  </div>
                  <span className="blog-text117">
                    <span className="blog-text118">
                      Last month, our team travelled to three rural communities
                      outside Lagos to conduct intensive Tech Innovation Camps
                      for over 120 high school students. Many of these students
                      had limited prior exposure to technology, but their
                      enthusiasm and quick learning amazed our entire team.
                    </span>
                    <br></br>
                    <span className="blog-text120">
                      &quot;I never thought I could build a website
                      myself,&quot; shared Oluwaseun, a 15-year-old participant.
                      &quot;Now I can create something that shows the world who
                      I am and what my community offers.&quot;...
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span>Read more</span>
                  </span>
                </div>
                <img
                  alt="Rectangle123092"
                  src="/external/rectangle123092-fzjt-600w.png"
                  className="blog-rectangle12"
                />
              </div>
            </div>
            <div className="blog-frame1143">
              <div className="blog-frame270">
                <span className="blog-text122">Other Posts</span>
                <span className="blog-text123">
                  Explore more articles on education, technology, and personal
                  growth.
                </span>
              </div>
              <div className="blog-frame1142">
                <div className="blog-frame260">
                  <div className="blog-frame2541">
                    <img
                      alt="Rectangle143071"
                      src="/external/rectangle143071-fah-300h.png"
                      className="blog-rectangle141"
                    />
                    <div className="blog-frame2531">
                      <div className="blog-frame2511">
                        <div className="blog-frame2502">
                          <span className="blog-text124">Insight</span>
                          <img
                            alt="Ellipse142911"
                            src="/external/ellipse142911-twuoi-200h.png"
                            className="blog-ellipse142"
                          />
                          <span className="blog-text125">March 5, 2025</span>
                        </div>
                        <div className="blog-frame2521">
                          <span className="blog-text126">
                            Faith and Technology: Finding the Balance in
                            Education
                          </span>
                          <span className="blog-text127">
                            <span className="blog-text128">
                              By
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ' ',
                                }}
                              />
                            </span>
                            <span className="blog-text129">
                              Pastor David Okafor,
                            </span>
                            <span> Faith Integration Specialist</span>
                          </span>
                        </div>
                      </div>
                      <span className="blog-text131">
                        <span className="blog-text132">
                          In today&apos;s rapidly advancing technological world,
                          many faith communities struggle with finding the
                          right...
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <span>Read more</span>
                      </span>
                    </div>
                  </div>
                  <div className="blog-frame2551">
                    <img
                      alt="Rectangle143071"
                      src="/external/rectangle143071-w7jn-300h.png"
                      className="blog-rectangle142"
                    />
                    <div className="blog-frame2532">
                      <div className="blog-frame2512">
                        <div className="blog-frame2503">
                          <span className="blog-text134">Insight</span>
                          <img
                            alt="Ellipse142961"
                            src="/external/ellipse142961-fryk-200h.png"
                            className="blog-ellipse143"
                          />
                          <span className="blog-text135">
                            February 28, 2025
                          </span>
                        </div>
                        <div className="blog-frame2522">
                          <span className="blog-text136">
                            Meet Our Graduates: Where Are They Now?
                          </span>
                          <span className="blog-text137">
                            <span className="blog-text138">
                              By
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ' ',
                                }}
                              />
                            </span>
                            <span className="blog-text139">
                              Michael Johnson,
                            </span>
                            <span> Alumni Relations Coordinator</span>
                          </span>
                        </div>
                      </div>
                      <span className="blog-text141">
                        <span className="blog-text142">
                          Five years ago, we launched our first comprehensive
                          tech education program with 25 ambitious students.
                          Today, we&apos;re proud to share...
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <span>Read more</span>
                      </span>
                    </div>
                  </div>
                  <div className="blog-frame2571">
                    <img
                      alt="Rectangle143071"
                      src="/external/rectangle143071-0h0f-300h.png"
                      className="blog-rectangle143"
                    />
                    <div className="blog-frame2533">
                      <div className="blog-frame2513">
                        <div className="blog-frame2504">
                          <span className="blog-text144">Insight</span>
                          <img
                            alt="Ellipse142961"
                            src="/external/ellipse142961-i0uv-200h.png"
                            className="blog-ellipse144"
                          />
                          <span className="blog-text145">
                            February 15, 2025
                          </span>
                        </div>
                        <div className="blog-frame2523">
                          <span className="blog-text146">
                            Partnership Spotlight: Grace Community Church
                            Launches Learning Hub
                          </span>
                          <span className="blog-text147">
                            <span className="blog-text148">
                              By
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ' ',
                                }}
                              />
                            </span>
                            <span className="blog-text149">
                              Rebecca Williams,
                            </span>
                            <span> Partnership Coordinator</span>
                          </span>
                        </div>
                      </div>
                      <span className="blog-text151">
                        <span className="blog-text152">
                          We&apos;re excited to announce our newest Community
                          Learning Hub in partnership with Grace...
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <span>Read more</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="blog-frame264">
                  <div className="blog-frame2552">
                    <img
                      alt="Rectangle132981"
                      src="/external/rectangle132981-0fr-300h.png"
                      className="blog-rectangle131"
                    />
                    <div className="blog-frame2534">
                      <div className="blog-frame2514">
                        <div className="blog-frame2505">
                          <span className="blog-text154">Insight</span>
                          <img
                            alt="Ellipse142981"
                            src="/external/ellipse142981-vqd9-200h.png"
                            className="blog-ellipse145"
                          />
                          <span className="blog-text155">
                            February 28, 2025
                          </span>
                        </div>
                        <div className="blog-frame2524">
                          <span className="blog-text156">
                            Meet Our Graduates: Where Are They Now?
                          </span>
                          <span className="blog-text157">
                            <span className="blog-text158">
                              By
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ' ',
                                }}
                              />
                            </span>
                            <span className="blog-text159">
                              Michael Johnson,
                            </span>
                            <span> Alumni Relations Coordinator</span>
                          </span>
                        </div>
                      </div>
                      <span className="blog-text161">
                        <span className="blog-text162">
                          Five years ago, we launched our first comprehensive
                          tech education program with 25 ambitious students.
                          Today, we&apos;re proud to share...
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <span>Read more</span>
                      </span>
                    </div>
                  </div>
                  <div className="blog-frame2572">
                    <img
                      alt="Rectangle132981"
                      src="/external/rectangle132981-vb9h-300h.png"
                      className="blog-rectangle132"
                    />
                    <div className="blog-frame2535">
                      <div className="blog-frame2515">
                        <div className="blog-frame2506">
                          <span className="blog-text164">Insight</span>
                          <img
                            alt="Ellipse142981"
                            src="/external/ellipse142981-szu-200h.png"
                            className="blog-ellipse146"
                          />
                          <span className="blog-text165">
                            February 15, 2025
                          </span>
                        </div>
                        <div className="blog-frame2525">
                          <span className="blog-text166">
                            Partnership Spotlight: Grace Community Church
                            Launches Learning Hub
                          </span>
                          <span className="blog-text167">
                            <span className="blog-text168">
                              By
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ' ',
                                }}
                              />
                            </span>
                            <span className="blog-text169">
                              Rebecca Williams,
                            </span>
                            <span> Partnership Coordinator</span>
                          </span>
                        </div>
                      </div>
                      <span className="blog-text171">
                        <span className="blog-text172">
                          We&apos;re excited to announce our newest Community
                          Learning Hub in partnership with Grace...
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <span>Read more</span>
                      </span>
                    </div>
                  </div>
                  <div className="blog-frame2542">
                    <img
                      alt="Rectangle132981"
                      src="/external/rectangle132981-l1k-300h.png"
                      className="blog-rectangle133"
                    />
                    <div className="blog-frame2536">
                      <div className="blog-frame2516">
                        <div className="blog-frame2507">
                          <span className="blog-text174">Insight</span>
                          <img
                            alt="Ellipse142981"
                            src="/external/ellipse142981-cgv-200h.png"
                            className="blog-ellipse147"
                          />
                          <span className="blog-text175">March 5, 2025</span>
                        </div>
                        <div className="blog-frame2526">
                          <span className="blog-text176">
                            Faith and Technology: Finding the Balance in
                            Education
                          </span>
                          <span className="blog-text177">
                            <span className="blog-text178">
                              By
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: ' ',
                                }}
                              />
                            </span>
                            <span className="blog-text179">
                              Pastor David Okafor,
                            </span>
                            <span> Faith Integration Specialist</span>
                          </span>
                        </div>
                      </div>
                      <span className="blog-text181">
                        <span className="blog-text182">
                          In today&apos;s rapidly advancing technological world,
                          many faith communities struggle with finding the
                          right...
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <span>Read more</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="blog-component3">
            <span className="blog-text184">Previous</span>
            <div className="blog-frame246"></div>
            <span className="blog-text185">Next</span>
          </div>
        </div>
        <div className="blog-frame217">
          <div className="blog-frame190">
            <div className="blog-group39">
              <img
                alt="Rectangle19304"
                src="/external/rectangle19304-i0qa-1100w.png"
                className="blog-rectangle1"
              />
              <div className="blog-grid">
                <div className="blog-group34">
                  <img
                    alt="Line519304"
                    src="/external/line519304-w0ae.svg"
                    className="blog-line51"
                  />
                  <img
                    alt="Line529304"
                    src="/external/line529304-p7nk.svg"
                    className="blog-line52"
                  />
                  <img
                    alt="Line539304"
                    src="/external/line539304-sfys.svg"
                    className="blog-line53"
                  />
                  <img
                    alt="Line549304"
                    src="/external/line549304-9en.svg"
                    className="blog-line54"
                  />
                  <img
                    alt="Line559304"
                    src="/external/line559304-ofa.svg"
                    className="blog-line55"
                  />
                  <img
                    alt="Line569304"
                    src="/external/line569304-8zyi.svg"
                    className="blog-line56"
                  />
                  <img
                    alt="Line579304"
                    src="/external/line579304-y59f.svg"
                    className="blog-line57"
                  />
                </div>
                <div className="blog-group33">
                  <img
                    alt="Line369304"
                    src="/external/line369304-9wop.svg"
                    className="blog-line36"
                  />
                  <img
                    alt="Line379304"
                    src="/external/line379304-h4qh.svg"
                    className="blog-line37"
                  />
                  <img
                    alt="Line389304"
                    src="/external/line389304-2rn4.svg"
                    className="blog-line38"
                  />
                  <img
                    alt="Line399304"
                    src="/external/line399304-jvvk.svg"
                    className="blog-line39"
                  />
                </div>
              </div>
              <img
                alt="childrenelectronicdevicesgadgetsconceptsmartconfid9304"
                src="/external/childrenelectronicdevicesgadgetsconceptsmartconfid9304-7e6-500h.png"
                className="blog-childrenelectronicdevicesgadgetsconceptsmartconfid"
              />
            </div>
            <div className="blog-frame122">
              <div className="blog-frame132">
                <span className="blog-text186">
                  Subscribe to our Newsletter
                </span>
                <span className="blog-text187">
                  Join our community of supporters and stay updated on how
                  we&apos;re empowering the next generation of leaders.
                </span>
              </div>
              <div className="blog-cta">
                <div className="blog-frame3">
                  <span className="blog-text188">example@gmail.com</span>
                </div>
                <div className="blog-component42">
                  <span className="blog-text189">Subscribe</span>
                </div>
              </div>
            </div>
          </div>
          <div className="blog-frame189">
            <div className="blog-frame184">
              <div className="blog-group107">
                <span className="blog-text190">Company</span>
                <div className="blog-frame2491">
                  <span className="blog-text191">Home</span>
                  <span className="blog-text192">About Us</span>
                  <span className="blog-text193">Contact Us</span>
                  <span className="blog-text194">Programs</span>
                  <span className="blog-text195">Approach</span>
                </div>
              </div>
              <div className="blog-group106">
                <span className="blog-text196">Quick Links</span>
                <div className="blog-frame2492">
                  <span className="blog-text197">Partner with Us</span>
                  <span className="blog-text198">Volunteer</span>
                  <span className="blog-text199">Donate</span>
                  <span className="blog-text200">Blog</span>
                </div>
              </div>
              <div className="blog-group105">
                <span className="blog-text201">Terms and Policies</span>
                <div className="blog-frame248">
                  <span className="blog-text202">Privacy Policy</span>
                  <span className="blog-text203">Terms and Conditions</span>
                  <span className="blog-text204">Feedback</span>
                  <span className="blog-text205">FAQs</span>
                </div>
              </div>
              <div className="blog-group104">
                <span className="blog-text206">Contact Information</span>
                <div className="blog-group87">
                  <span className="blog-text207">connect@futureheirs.org</span>
                  <div className="blog-vuesaxboldsms1">
                    <div className="blog-vuesaxboldsms2">
                      <div className="blog-sms">
                        <img
                          alt="VectorI290"
                          src="/external/vectori290-qtg.svg"
                          className="blog-vector2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="blog-group88">
                  <span className="blog-text208">
                    123 Faith &amp; Innovation Way, Your City, State 12345
                  </span>
                  <div className="blog-vuesaxboldlocation1">
                    <div className="blog-vuesaxboldlocation2">
                      <img
                        alt="VectorI290"
                        src="/external/vectori290-sw78.svg"
                        className="blog-vector3"
                      />
                    </div>
                  </div>
                </div>
                <div className="blog-group89">
                  <span className="blog-text209">(555) 123-4567</span>
                  <div className="blog-vuesaxboldcall1">
                    <div className="blog-vuesaxboldcall2">
                      <div className="blog-call">
                        <img
                          alt="VectorI290"
                          src="/external/vectori290-z6wz.svg"
                          className="blog-vector4"
                        />
                        <img
                          alt="VectorI290"
                          src="/external/vectori290-uh6h.svg"
                          className="blog-vector5"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              alt="Line2I290"
              src="/external/line2i290-mugm.svg"
              className="blog-line2"
            />
            <div className="blog-frame183">
              <div className="blog-frame161">
                <img
                  alt="VectorI290"
                  src="/external/vectori290-ygrl.svg"
                  className="blog-vector6"
                />
                <span className="blog-text210">futureheirs</span>
              </div>
              <div className="blog-frame180">
                <span className="blog-text211">Follow Us:</span>
                <div className="blog-frame177">
                  <div className="blog-vuesaxboldfacebook1">
                    <div className="blog-vuesaxboldfacebook2">
                      <div className="blog-facebook">
                        <img
                          alt="VectorI290"
                          src="/external/vectori290-lll8.svg"
                          className="blog-vector7"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    alt="riinstagramfillI290"
                    src="/external/riinstagramfilli290-qo9j.svg"
                    className="blog-riinstagramfill"
                  />
                  <img
                    alt="pajamaslinkedinI290"
                    src="/external/pajamaslinkedini290-yl3m.svg"
                    className="blog-pajamaslinkedin"
                  />
                  <img
                    alt="fa6brandssquarextwitterI290"
                    src="/external/fa6brandssquarextwitteri290-yrv.svg"
                    className="blog-fa6brandssquarextwitter"
                  />
                  <div className="blog-vuesaxboldyoutube1">
                    <div className="blog-vuesaxboldyoutube2">
                      <div className="blog-youtube">
                        <img
                          alt="VectorI290"
                          src="/external/vectori290-5j1.svg"
                          className="blog-vector8"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Blog
